import React from 'react';
import classNames from 'classnames';

import { i18n } from '@lt/localization';
import { QuestionOutline as QuestionOutlineIcon } from '@lt/components/icons-react/rebrand';
import { Bubble } from '@lt/components';
import { VISA_TYPES, VISA_NAMES } from '../../store/domains/visa';
import type { IVisaInfo } from '../../CheckoutRoutes/PackageCheckout/components/Hotel/components/types';

import styles from './visaInfo.module.css';

const getVisaDescription = (type, visaSupport) => {
  switch (type) {
    case VISA_TYPES.NO_VISA:
      return '';
    case VISA_TYPES.ON_ARRIVAL_VISA:
      return i18n.t('checkout.visa.onArrival.description');
    default:
      return i18n.t('checkout.visa.support', {
        context: visaSupport ? '' : 'no',
      });
  }
};

const VisaInfo = ({
  type,
  visaSupport,
  className = '',
  isMobile = false,
}: IVisaInfo): JSX.Element => {
  const description = getVisaDescription(type, visaSupport);
  return (
    <Bubble className={className} disabled={!description} text={description}>
      <>
        <div
          className={classNames(styles.label, {
            [styles.mobileLabel]: isMobile,
          })}
        >
          {VISA_NAMES[type]}
        </div>
        {description && <QuestionOutlineIcon className={styles.icon} />}
      </>
    </Bubble>
  );
};

export default VisaInfo;
